export default {
    header: 'Uups, etwas ist schief gelaufen',
    text: 'Bitte starte die Seite neu oder klicke unten auf den Button "Zurück zum Menü".',
    button: 'Zurück zum Menü',
}